import React from 'react';
import { useLocation } from 'react-router-dom';
import { v1 } from 'uuid';
import { minimalRoleRequired } from 'utils';

import Item from 'components/Nav/Item';
import './nav.style.scss';

const Nav = ({ user, items }) => {
  const location = useLocation();

  return (
    <React.Fragment>
      <div
        className="nav"
        style={{
          opacity: 1,
          visibility: 'visible',
          height: '50px'
        }}
      >
        <div className="nav-contains">
          {items.map(
            (e) =>
              minimalRoleRequired(user?.role, e.minimalRole) && (
                <Item
                  key={v1()}
                  path={`/${e.path}`}
                  text={e.text}
                  active={`/${e.path}` === location.pathname}
                />
              )
          )}
        </div>
      </div>
      <div className="marginNav"></div>
    </React.Fragment>
  );
};

export default Nav;
